import AbstractMain from 'frontools/abstract/AbstractMain';
import Breakpoint from 'frontools/core/Breakpoint';
import Page from 'sources/ts/pages/Page';

export class Main extends AbstractMain {

    public breakpoint               : Breakpoint;

    constructor(context:Object = {}) {
        super(context);

        new Page();

        Breakpoint.trigger();
    }


    /*
    * Override breakpoints init to add new groups
    */
   protected initBreakpoint() {
    this.breakpoint = new Breakpoint({
        debug: true,
        breakpoints: [
            Breakpoint.MOBILES = 'mobiles',
            Breakpoint.MOBILE = 'mobile',
            Breakpoint.TABLETP = 'tabletp',
            Breakpoint.TABLET = 'tablet',
            Breakpoint.DESKTOP = 'desktop',
            Breakpoint.LARGE = 'large',
            Breakpoint.HD = 'hd'
        ],
        groups: {
            'group_mobile': [
                Breakpoint.MOBILES,
                Breakpoint.MOBILE,
                Breakpoint.TABLETP,
                Breakpoint.TABLET,
            ],
            'group_desktop': [
                Breakpoint.DESKTOP,
                Breakpoint.LARGE,
                Breakpoint.HD
            ],
            'group_small': [
                Breakpoint.MOBILES,
                Breakpoint.MOBILE,
                Breakpoint.TABLETP,
                Breakpoint.TABLET
            ],
            'group_large': [
                Breakpoint.DESKTOP,
                Breakpoint.LARGE,
                Breakpoint.HD
            ],
        }
    });
}

}
